export default __webpack_public_path__ + "static/media/Moonear.a3af4dd0.jpg";